export {
  LinkColor,
  LinkComponent,
  LinkHoverColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
  QueryParams,
} from './link.component';
export { LinkModule } from './link.module';
